import { toast } from "react-hot-toast"

import rzpLogo from "../../assets/Logo/rzp_logo.png"
import { resetCart } from "../../slices/cartSlice"
import { setPaymentLoading } from "../../slices/courseSlice"
import { apiConnector } from "../apiConnector"
import { studentEndpoints } from "../apis"

const {
  COURSE_PAYMENT_API,
  COURSE_VERIFY_API,
  SEND_PAYMENT_SUCCESS_EMAIL_API,
} = studentEndpoints

// Load the Razorpay SDK from the CDN
function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script")
    script.src = src
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      resolve(false)
    }
    document.body.appendChild(script)
  })
}

// Buy the Course
export async function BuyCourse(token, courses, user_details, navigate, dispatch) {
  const toastId = toast.loading("Loading...")

  try {
    // Step 1: Load Razorpay SDK
    const sdkLoaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js")
    if (!sdkLoaded) {
      toast.dismiss(toastId)
      toast.error("Failed to load Razorpay SDK.")
      console.error("Razorpay SDK load failed.")
      return
    }
    // console.log("Razorpay SDK loaded successfully.")

    // Step 2: Create order
    const orderResponse = await apiConnector(
      "POST",
      COURSE_PAYMENT_API,
      { courses },
      {
        Authorization: `Bearer ${token}`,
      }
    )

    // console.log("ORDER RESPONSE:", orderResponse)

    if (!orderResponse?.data?.success) {
      throw new Error(orderResponse?.data?.message || "Order creation failed")
    }

    const { data, key } = orderResponse.data
    console.log("RAZORPAY KEY:", key)
    console.log("Order data:", data)

    const options = {
      key,
      currency: data.currency,
      amount: `${data.amount}`,
      order_id: data.id,
      name: "StudyNotion",
      description: "Thank you for purchasing the course.",
      image: rzpLogo,
      prefill: {
        name: `${user_details.firstName} ${user_details.lastName}`,
        email: user_details.email,
      },
      handler: function (response) {
        console.log("Razorpay Payment Success Response:", response)
        verifyPayment({ ...response, courses }, token, navigate, dispatch)
      },
      modal: {
        ondismiss: function () {
          console.warn("Payment popup was closed by the user.")
          toast.error("Payment was cancelled.")
        },
      },
    }

    // console.log("Razorpay Options:", options)

    const paymentObject = new window.Razorpay(options)
    paymentObject.open()

    paymentObject.on("payment.failed", function (response) {
      console.error("Payment Failed Event:", response.error)
      toast.error("Oops! Payment failed.")
    })

  } catch (error) {
    console.error("Error in BuyCourse:", error)
    toast.error("Could not process payment.")
  }

  toast.dismiss(toastId)
}
// Verify the Payment
async function verifyPayment(bodyData, token, navigate, dispatch) {
  const toastId = toast.loading("Verifying Payment...")
  dispatch(setPaymentLoading(true))
  try {
    const response = await apiConnector("POST", COURSE_VERIFY_API, bodyData, {
      Authorization: `Bearer ${token}`,
    })

    // console.log("VERIFY PAYMENT RESPONSE FROM BACKEND............", response)

    if (!response.data.success) {
      throw new Error(response.data.message)
    }

    toast.success("Payment Successful. You are Added to the course ")
    navigate("/dashboard/enrolled-courses")
    dispatch(resetCart())
  } catch (error) {
    console.log("PAYMENT VERIFY ERROR............", error)
    toast.error("Could Not Verify Payment.")
  }
  toast.dismiss(toastId)
  dispatch(setPaymentLoading(false))
}

// Send the Payment Success Email
async function sendPaymentSuccessEmail(response, amount, token) {
  try {
    await apiConnector(
      "POST",
      SEND_PAYMENT_SUCCESS_EMAIL_API,
      {
        orderId: response.razorpay_order_id,
        paymentId: response.razorpay_payment_id,
        amount,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    )
  } catch (error) {
    console.log("PAYMENT SUCCESS EMAIL ERROR............", error)
  }
}
